<template>
    <!-- Componente del Slider de promociones -->
    <div class="carousel sm:px-4 lg:px-12">
        <VueSlickCarousel ref="slick" v-bind="slickOptions" class="max-w-screen-xxl mx-auto">
            <!-- <div
                v-for="(promotion, index) in promotions"
                :key="index"
                class="w-full h-40 sm:h-80 lg:h-72 xl:h-96 xxl:h-108 bg-no-repeat bg-center bg-cover"
                :style="{'background-image': imageType === 'mobile' ? `url(${url}/storage${promotion.mobile})` : `url(${url}/storage${promotion.desktop})`}">
                <div class="sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-3/12 xxl:w-4/12 h-full ml-3 sm:ml-6 mt-4 sm:mt-16 md:ml-10 lg:mt-20 lg:ml-6 xl:ml-20 xl:mt-28 xxl:mt-16">
                    <h1 class="text-lg sm:text-4xl font-medium sm:leading-tight lg:leading-11">{{promotion.title}}</h1>
                    <p class="w-40 sm:w-auto xxl:w-96 text-sm leading-tight sm:leading-normal">
                        {{promotion.description}}
                    </p>
                    <a class="block w-32 sm:w-40 text-center text-xs sm:text-sm bg-dark-blue text-white py-2 my-4" :href="promotion.link" target="_blank">Conoce más</a>
                </div>
            </div> -->

            <div v-if="showCarousel" v-for="(promotion, index) in promotions" :key="index">
                <a
                    :is="getPromoLink(promotion) ? 'a' : 'div'"
                    :href="`${getPromoLink(promotion)}`"
                    :target="getPromoTarget(promotion)"
                >
                    <picture>
                        <!-- <source v-if="imageType === 'mobile'" type="image/webp" :srcset="getWebpSrc(`${url}/storage${promotion.mobile}`)"> -->
                        <source
                            type="image/jpeg"
                            :srcset="imageType === 'mobile' ? promotion.mobile : promotion.desktop"
                        />
                        <img
                            :width="imageType === 'mobile' ? '1008' : '1801'"
                            height="540"
                            :id="`banner-${index + 1}`"
                            :src="imageType === 'mobile' ? promotion.mobile : promotion.desktop"
                            :alt="promotion.title"
                        />
                    </picture>
                </a>
                <!-- <img v-else :width="imageType === 'mobile' ? '1008' : '1801'" height="540" :src="imageType === 'mobile' ? `${url}/storage${promotion.mobile}` : `${url}/storage${promotion.desktop}`" :alt="promotion.title"> -->
            </div>
            <div v-if="webpage === 'farrera'">
                <a :href="`/${webpage}/tyc/71/Before-Service-Merida`">
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        :src="
                            imageType === 'mobile'
                                ? `${url}/images/news/BF_DealerHomeBanner_1008x540_merida.webp`
                                : `${url}/images/news/BF_DealerHomeBanner_1801x540_merida.webp`
                        "
                        alt="2022 - 10 - Before Service"
                    />
                </a>
            </div>

            <div v-else>
                <a :href="`/${webpage}/tyc/70/Before-Service-Nacional`">
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        :src="
                            imageType === 'mobile'
                                ? `${url}/images/news/BF_DealerHomeBanner_1008x540_Nacional.webp`
                                : `${url}/images/news/BF_DealerHomeBanner_1801x540_Nacional.webp`
                        "
                        alt="2022 - 10 - Before Service"
                    />
                </a>
            </div>
            <div v-if="hyundaiPromise">
                <a :href="`${url}/${webpage}/seminuevos`">
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        :src="
                            imageType === 'mobile'
                                ? `${urlCdn}/news/images/promise/Seminuevos_DealerHomeBanner_1008x540_1.jpg`
                                : `${urlCdn}/news/images/promise/Seminuevos_DealerHomeBanner_1801x540_1.jpg`
                        "
                        alt="2022 – 06 – Seminuevos – Grand i10 HB"
                    />
                </a>
            </div>
            <!-- <div v-if="parseInt(this.tallerMovil)">
                <a :href="`${url}/${webpage}/servicios/agenda-tu-cita`">
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        :src="imageType === 'mobile' ? `${url}/images/news/TallerMovil_DealerHomeBanner_1008x540.jpg` : `${url}/images/news/TallerMovil_DealerHomeBanner_1801x540.jpg`"
                        alt="2021 - Oct - Taller Móvil - Tucson 2022"
                    >
                </a>
            </div>
            <div v-if="parseInt(this.comunicado)">
                <img
                    :width="imageType === 'mobile' ? '1008' : '1801'"
                    height="540"
                    :src="imageType === 'mobile' ? `${url}/images/news/ComunicadoDealers_1008x540.jpg` : `${url}/images/news/ComunicadoDealers_1801x540.jpg`"
                    alt="2021 - Ene - Comunicado Oficial - N/A"
                >
            </div>
            <div v-if="parseInt(this.news)">
                <a :href="`${url}/${webpage}/noticias`">
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        id="banner-noticias"
                        :src="imageType === 'mobile' ? `${url}/images/news/Mayo_1008x540.jpg` : `${url}/images/news/Mayo_1801x540.jpg`"
                        alt="2021 - May - #HyundaiTeAcompaña - N/A"
                    >
                </a>
            </div>
            <div v-if="paymentBanner.show">
                <a
                    :href="paymentBanner.url"
                    target="_blank"
                >
                    <img
                        :width="imageType === 'mobile' ? '1008' : '1801'"
                        height="540"
                        id="banner-pago"
                        :src="imageType === 'mobile' ? `${url}/images/news/payment_banner_1008x540.jpg` : `${url}/images/news/payment_banner_1801x540.jpg`"
                        alt="2021 - Jun - Pago en línea - N/A"
                    >
                </a>
            </div> -->
            <template #customPaging="page">
                <div
                    class="custom-dot h-2 w-2 sm:h-3 sm:w-3 bg-white rounded-lg border-brown border-solid border box-content"
                ></div>
            </template>
        </VueSlickCarousel>
        <div v-if="showDot" class="slick-dots">
            <div
                class="custom-dot h-2 w-2 sm:h-3 sm:w-3 bg-light-blue rounded-lg border-brown border-solid border box-content"
            ></div>
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
    props: ["promotions", "hyundaiPromise"],
    components: { VueSlickCarousel },
    data() {
        return {
            urlCdn: "https://cdn.hyundaidistribuidor.com.mx",
            // Variable para almacenar la url base del sitio
            url: $(".url").text(),
            // Variable para almacenar el slug del distribuidor
            webpage: $(".webpage").text(),
            // Variable para almacenar las opciones para el Slider
            slickOptions: {
                arrows: false,
                dots: true,
                autoplay: true,
                speed: 2500,
                autoplaySpeed: 8000,
                lazyLoad: "progressive",
            },
            // promotions: [],
            // promosResp: false,
            // Variable para determinar el tipo de imágenes
            // para el slider
            imageType: "mobile",
        };
    },
    methods: {
        // getPromotions() {
        //     axios.get(`${this.url}/${this.webpage}/get-promotions`)
        //     .then(resp => {
        //         //this.promotions = resp.data
        //         var promotions  = resp.data
        //         var webpage1    = $('.webpage').text()

        //         $.each( promotions, function( index, value ) {
        //             // console.log(index, value, 'MARIONELO');

        //             try {
        //                 if (value.link) {
        //                     if ( value.link.search('https') == -1 ) {
        //                         promotions[index].link = `/${webpage1}${promotions[index].link}`;
        //                     }
        //                 }
        //             } catch (error) {
        //                 console.log(error);
        //             }

        //         } )

        //         this.promosResp = true
        //         this.promotions = promotions
        //         this.showSpecialPromo()
        //         this.showPaymentBanner()

        //     })
        //     .catch(err => {
        //         console.log(err)
        //     })
        // },
        // showSpecialPromo() {
        //     axios.get(`${this.url}/show-news/${this.geoStateId}/${this.webpage}/`)
        //         .then(resp => {
        //             this.specialPromo = resp.data
        //             this.spPromoResp = true
        //         })
        //         .catch(err => console.log(err))
        // },
        // showPaymentBanner() {
        //     axios.get(`${this.url}/payment-banner/${this.geoStateId}/${this.webpage}/`)
        //         .then(resp => {
        //             this.paymentBanner.resp = true
        //             this.paymentBanner.show = resp.data.show
        //             this.paymentBanner.url = resp.data.url
        //         })
        //         .catch(err => console.log(err))
        // },
        afterSlideChange() {
            // this.$refs.slick.pause()
            // setTimeout(() => this.$refs.slick.play(), 1000)
        },
        // Función para determinar el tipo de imágenes a mosrar
        // en el slider
        onResize() {
            if (window.innerWidth < 1024) {
                this.imageType = "mobile";
            } else if (window.innerWidth >= 1024) {
                this.imageType = "desktop";
            }
        },
        // Función para obtener el link de los banners de las promociones
        getPromoLink(promo) {
            let promoLink = null;
            if (promo.link) {
                if (promo.link.search("http") === -1) {
                    promoLink = `/${this.webpage}${promo.link}`;
                } else {
                    promoLink = promo.link;
                }
            }
            return promoLink;
        },
        // getWebpSrc(imgUrl) {
        //     return imgUrl.replace("jpg", "webp");
        // },
        // Función para determinar como abrir los links
        // al dar clic a los banners de las promociones
        getPromoTarget(promotion) {
            if (promotion.link) {
                return promotion.link.search("http") != -1 ? "_blank" : "_self";
            } else {
                return "";
            }
        },
        getImageUrl(imgUrl) {
            console.log(typeof imgUrl);
            if (imgUrl.includes("cdn")) {
                imgUrl = imgUrl.replace("cdn", "https://cdn.hyundaidistribuidor.com.mx");
            } else {
                imgUrl = `${this.url}/storage${imgUrl}`;
            }
            return imgUrl;
        },
        formatImages() {
            this.slickOptions.arrows = true;
            for (let [key, promotion] of this.promotions.entries()) {
                this.promotions[key].desktop = this.getImageUrl(promotion.desktop);
                this.promotions[key].mobile = this.getImageUrl(promotion.mobile);
            }
            this.slickOptions.arrows = false;
        },
    },
    computed: {
        // Retorna un valor booleano para determinar
        // si mostrar un solo punto en el slider
        showDot() {
            let numBanners = 0;
            numBanners += this.promotions.length;
            numBanners += this.paymentBanner.show ? 1 : 0;
            numBanners += parseInt(this.comunicado);
            numBanners += parseInt(this.news);
            numBanners += parseInt(this.tallerMovil);
            numBanners += parseInt(this.rioMayoBanner);
            return numBanners == 1;
        },
        // Retorna un valor booleano para determinar
        // si mostrar el slider o no
        showCarousel() {
            return Boolean(this.promotions.length);
        },
        showDot() {
            return Boolean(this.promotions.length === 1);
        },
        // showDot() {
        //     let numBanners = 0
        //     numBanners += this.promotions.length
        //     numBanners += this.paymentBanner.show ? 1 : 0
        //     numBanners += parseInt(this.comunicado)
        //     numBanners += parseInt(this.news)
        //     numBanners += parseInt(this.tallerMovil)
        //     numBanners += parseInt(this.rioMayoBanner)
        //     return numBanners == 1
        // },
        // showCarousel() {
        //     return this.promotions.length > 0 || this.paymentBanner.show || parseInt(this.rioMayoBanner) || parseInt(this.tallerMovil) || parseInt(this.comunicado) || parseInt(this.news)
        // }
    },
    created() {
        // this.getPromotions()
        window.addEventListener("resize", this.onResize);
        this.formatImages();
    },
    mounted() {
        this.onResize();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
};
</script>

<style lang="scss">
.slick-dots {
    display: flex !important;
    justify-content: center;
    padding: 1rem 0;

    li {
        margin: 0 0.25rem;

        &.slick-active {
            .custom-dot {
                background-color: #00aad2;
            }
        }
    }
}

@media only screen and (min-width: 1024px) {
    .slick-dots {
        padding: 1.3rem 0;
    }
}
</style>
